const MSLConnect = () => {
  //check if page is publications (id 239)
  if (document.querySelector('.page.page-id-239')) {

    let selectedArea = null;
    let selectedState = null;
    let productData = null;

    //get product data
    if (sessionStorage.getItem('productData') === null) {
      // if product data is not in session storage, fetch it
      fetch('/api/mira/v1/products')
        .then(response => response.json())
        .then(data => {
          productData = data;
          sessionStorage.setItem('productData', JSON.stringify(productData));
        });
    } else {
      //if product data is in session storage, get it
      productData = JSON.parse(sessionStorage.getItem('productData'));
    }

    /*
    Event Listeners
    */

    //remove submit on cf7 form
    document.querySelector('form.wpcf7-form').addEventListener('submit', (e) => {
      e.preventDefault();
    });

    //state dropdown change
    document.querySelector('select[name="state"]').addEventListener('change', (e) => {
      if (document.querySelector('label[for="state"] .text-danger'))
        document.querySelector('label[for="state"] .text-danger').remove();

      //if value is empty, reset selectedState
      if (e.target.value === "") {
        selectedState = null;
        document.querySelector('.wpcf7-form-control.wpcf7-submit').classList.remove('active');
        return;
      }

      //toggle submit button depending on values
      if (document.querySelector('select[name="product"]').value !== "") {
        document.querySelector('.wpcf7-form-control.wpcf7-submit').classList.add('active');
      } else {
        document.querySelector('.wpcf7-form-control.wpcf7-submit').classList.remove('active');
      }

      selectedState = getUSStateCode(e.target.value);

      //delete wpcf7-not-valid-tip if it exists
      if (document.querySelector('.wpcf7-not-valid-tip'))
        document.querySelector('.wpcf7-not-valid-tip').remove();

      console.log({
        event : 'mslState',
        eventModel: {
          q_State : e.target.value,
          }
        });

      dataLayer.push({
        event : 'mslState',
        eventModel: {
          q_State : e.target.value,
          }
        });
    });

    //product dropdown change
    document.querySelector('select[name="product"]').addEventListener('change', (e) => {
      if (document.querySelector('label[for="product"] .text-danger'))
        document.querySelector('label[for="product"] .text-danger').remove();

      //grab all TA dropdown options
      let ta = document.querySelector('select[name="therapeutic-area"]'),
          taOptions = ta.querySelectorAll('option[data-prods]');

      taOptions.forEach(option => {
          option.classList.remove('active');
        });

      //if value is empty, reset selectedArea
      if (e.target.value === "") {
        selectedArea = null;
        document.querySelector('.wpcf7-form-control.wpcf7-submit').classList.remove('active');

        ta.selectedIndex = 0;
        ta.setAttribute('disabled', true);
        ta.parentElement.classList.add('disabled');

        return;
      } else {
        ta.removeAttribute('disabled');
        ta.parentElement.classList.remove('disabled');
      }

      //toggle submit button depending on values
      if (document.querySelector('select[name="state"]').value !== "") {
        document.querySelector('.wpcf7-form-control.wpcf7-submit').classList.add('active');
      } else {
        document.querySelector('.wpcf7-form-control.wpcf7-submit').classList.remove('active');
      }

      //split product name by reg symbol
      const name = e.target.value.split('®')[0].toLowerCase();

      //loop through productData to find product therapeutic area
      productData.forEach(product => {
        if (product.name.toLowerCase() === name) {
          selectedArea = product.therapeutic_areas[0].slug;
        }
      });

      if (name === 'other') {
        selectedArea = 'other'; //allow 'other' to be passed through to MSL search as a therapeutic area

        //loop through and filter all TA dropdown options
        taOptions.forEach(option => {
          let prods = option.getAttribute('data-prods');

          if (prods.length) {
            option.classList.remove('active');
          } else {
            option.classList.add('active');
          }

          if (ta.querySelectorAll('option[data-prods].active').length) {
            ta.querySelectorAll('option[data-prods].active').forEach(option => {
              if (/respiratory/.test(option.innerHTML.toLowerCase())) {
                ta.selectedIndex = option.getAttribute('data-index')
              }
            });

            if (ta.selectedIndex == 0) {
              ta.selectedIndex = ta.querySelectorAll('option[data-prods].active')[0].getAttribute('data-index');
            }
          }
        });

        if (ta.selectedIndex > 0) {
          selectedArea = ta.value;
        }
      } else {
        //loop through and filter all TA dropdown options
        taOptions.forEach(option => {
          let prods = option.getAttribute('data-prods');

          if (prods.length) {
            let prodList = prods.split('|');

            if (prodList.includes(name.toUpperCase())) {
              option.classList.add('active');
            } else {
              option.classList.remove('active');
            }
          }
        });

        if (ta.querySelectorAll('option[data-prods].active').length) {
          ta.selectedIndex = ta.querySelectorAll('option[data-prods].active')[0].getAttribute('data-index');
        }
      }

      if (document.querySelector('.wpcf7-not-valid-tip'))
        document.querySelector('.wpcf7-not-valid-tip').remove();

      console.log({
        event : 'mslProduct',
        eventModel: {
          q_Product : e.target.value,
          }
        });

      dataLayer.push({
        event : 'mslProduct',
        eventModel: {
          q_Product : e.target.value,
          }
        });
    });

    //submit button
    document.querySelector('.wpcf7-submit').addEventListener('click', (e) => {
      e.preventDefault();
      getData();

      console.log({
        event : 'mslClick',
        eventModel: {
          q_State : document.querySelector('select[name="state"]').value,
          q_Product : document.querySelector('select[name="product"]').value,
          }
        });

      dataLayer.push({
        event : 'mslClick',
        eventModel: {
          q_State : document.querySelector('select[name="state"]').value,
          q_Product : document.querySelector('select[name="product"]').value,
          }
        });
    });


    /*
    Functions
    */

    function getUSStateCode(stateName) {
      const states = {
        'Alabama': 'AL',
        'Alaska': 'AK',
        'Arizona': 'AZ',
        'Arkansas': 'AR',
        'California': 'CA',
        'Colorado': 'CO',
        'Connecticut': 'CT',
        'Delaware': 'DE',
        'Florida': 'FL',
        'Georgia': 'GA',
        'Hawaii': 'HI',
        'Idaho': 'ID',
        'Illinois': 'IL',
        'Indiana': 'IN',
        'Iowa': 'IA',
        'Kansas': 'KS',
        'Kentucky': 'KY',
        'Louisiana': 'LA',
        'Maine': 'ME',
        'Maryland': 'MD',
        'Massachusetts': 'MA',
        'Michigan': 'MI',
        'Minnesota': 'MN',
        'Mississippi': 'MS',
        'Missouri': 'MO',
        'Montana': 'MT',
        'Nebraska': 'NE',
        'Nevada': 'NV',
        'New Hampshire': 'NH',
        'New Jersey': 'NJ',
        'New Mexico': 'NM',
        'New York': 'NY',
        'North Carolina': 'NC',
        'North Dakota': 'ND',
        'Ohio': 'OH',
        'Oklahoma': 'OK',
        'Oregon': 'OR',
        'Pennsylvania': 'PA',
        'Rhode Island': 'RI',
        'South Carolina': 'SC',
        'South Dakota': 'SD',
        'Tennessee': 'TN',
        'Texas': 'TX',
        'Utah': 'UT',
        'Vermont': 'VT',
        'Virginia': 'VA',
        'Washington': 'WA',
        'West Virginia': 'WV',
        'Wisconsin': 'WI',
        'Wyoming': 'WY'
      };

      return states[stateName].toLowerCase();
    }

    function getData() {
      if (document.querySelector('label[for="state"] .text-danger')) document.querySelector('label[for="state"] .text-danger').remove();
      if (document.querySelector('label[for="product"] .text-danger')) document.querySelector('label[for="product"] .text-danger').remove();

      //check if state and product are selected
      if (!selectedState) {
        //show error message
        const errorText = document.createElement('span');
        errorText.setAttribute('style', 'font-size: 13px; font-weight: 500; margin-left:5px; font-style: italic; color: #DB0000;');
        errorText.innerHTML = "field required";
        errorText.classList.add('text-danger');
        document.querySelector('label[for="state"]').appendChild(errorText);
      }

      if (!selectedArea) {
        //show error message
        const errorText = document.createElement('span');
        errorText.setAttribute('style', 'font-size: 13px; font-weight: 500; margin-left:5px; font-style: italic; color: #DB0000;');
        errorText.innerHTML = "field required";
        errorText.classList.add('text-danger');
        document.querySelector('label[for="product"]').appendChild(errorText);
      }


      if (selectedArea && selectedState) {
        //clear results
        document.querySelector('[data-widget="msl-results"]').innerHTML = "";

        //grab all TA dropdown options
        let ta = document.querySelector('select[name="therapeutic-area"]'),
            taOptions = ta.querySelectorAll('option[data-prods]');

        if (ta.selectedIndex > 0) {
          selectedArea = ta.value;
        } else {
          selectedArea = 'other';
        }

        fetch(`/api/mira/v1/msls/state=${selectedState}/therapeutic_area=${selectedArea}`)
          .then(response => response.json())
          .then(data => {
            if (typeof data === 'object') {
              data.forEach(msl => {
                renderRow(msl);
              });
            } else {
              alert('No results to show.');
            }
          })
          .catch(error => {
            console.log(error);
          })
      }
    }

    function renderRow(data) {
      //render row

      //if bio contains <p> tags, remove them
      let bio = data.bio;
      bio = bio.replace('&lt;p&gt;', '');
      bio = bio.replace('&lt;/p&gt;', '');

      const container = document.querySelector('[data-widget="msl-results"]')
      const row = document.createElement('div');

      row.innerHTML = (function(data, bio){
        var h = [
          '<div class="card">',
            '<div class="card-body">',
              '<div class="row mb-3 mb-sm-0">',
                '<div class="col-5 col-md-4 col-lg-3 px-lg-0">',
                  (data.image ? ('<img src="'+data.image.url+'" alt="'+data.fullname+'">') : ''),
                '</div>',
                '<div class="col-7 col-md-8 col-lg-9 ps-lg-5">',
                  '<div data-obj="name">',
                    '<span>'+data.fullname+'</span>',
                  '</div>',
                  '<div data-obj="terr" class="d-flex align-items-start">',
                    '<span></span>',
                    '<span>'+data.territories.join(", ")+'</span>',
                  '</div>',
                  '<div data-obj="spec" class="d-flex align-items-start">',
                    '<span></span>',
                    '<span>'+data.therapeutic_areas.join(', ')+'</span>',
                  '</div>',
                  '<div data-obj="bio" class="d-none d-sm-block mt-3">',
                    '<p>'+bio+'</p>',
                    '<div data-obj="email">',
                      '<a href="mailto:'+data.email+'">'+data.email+'</a>',
                    '</div>',
                  '</div>',
                '</div>',
              '</div>',
              '<div class="row d-sm-none">',
                '<div class="col-12">',
                  '<div data-obj="bio">',
                    '<p>'+bio+'</p>',
                    '<div data-obj="email">',
                      '<a href="mailto:'+data.email+'">'+data.email+'</a>',
                    '</div>',
                  '</div>',
                '</div>',
              '</div>',
            '</div>',
        ];
        return h.join('').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '');
      })(data, bio);

      container.appendChild(row);
    }
  }
};

export default MSLConnect;
